"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./getDynamicCode"), exports);
//# sourceMappingURL=index.js.map